import { RouterProvider as RouterDomProvider } from 'react-router-dom';

import { useUserRole } from 'applications/GSP/shared/hooks/user';
import { Loader } from 'shared/components/Loader';

import { useRouter } from './hooks';

export const RouterProvider = () => {
  const userRole = useUserRole();
  const router = useRouter(userRole);

  return <RouterDomProvider fallbackElement={<Loader />} router={router} />;
};
